import type { ReactElement } from "react";
import { AuthForm } from "./AuthForm";

interface LoginFormProps {
	onSuccess?: () => void;
	signupUrl?: string;
	redirectPath?: string;
}

export function LoginForm({
	onSuccess,
	signupUrl = "/signup",
	redirectPath,
}: LoginFormProps): ReactElement {
	return (
		<AuthForm
			mode="login"
			onSuccess={onSuccess}
			switchUrl={signupUrl}
			redirectPath={redirectPath}
		/>
	);
}
